import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddTaxRates({ open, onClose, setOpen }: ModalProps) {
    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");
    const [taxType, setTaxType] = useState("");
    const [rate, setRate] = useState("");

    const handleCountryChange = (event: SelectChangeEvent) => {
        setCountry(event.target.value);
        setRegion(""); // reset region when country changes
    };

    const handleRegionChange = (event: SelectChangeEvent) => {
        setRegion(event.target.value);
    };

    const handleTaxTypeChange = (event: SelectChangeEvent) => {
        setTaxType(event.target.value);
    };

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={onClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <h2>Create Tax Rate</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">

                            {/* Country */}
                            <div className="control_group w_50">
                                <label htmlFor="tax-country">Country</label>
                                <Select
                                    fullWidth
                                    value={country}
                                    onChange={handleCountryChange}
                                    defaultValue="select"
                                    inputProps={{ id: "tax-country" }}
                                >
                                    <MenuItem value="select">Select</MenuItem>
                                    <MenuItem value="UAE">UAE</MenuItem>
                                    <MenuItem value="India">India</MenuItem>
                                    <MenuItem value="USA">USA</MenuItem>
                                </Select>
                            </div>

                            {/* Region */}
                            <div className="control_group w_50">
                                <label htmlFor="tax-region">Region / State</label>
                                <Select
                                    fullWidth
                                    value={region}
                                    onChange={handleRegionChange}
                                    disabled={!country}
                                    inputProps={{ id: "tax-region" }}
                                >
                                    {country === "UAE" && (
                                        <>
                                            <MenuItem value="Dubai">Dubai</MenuItem>
                                            <MenuItem value="Abu Dhabi">Abu Dhabi</MenuItem>
                                        </>
                                    )}
                                    {country === "India" && (
                                        <>
                                            <MenuItem value="Maharashtra">Maharashtra</MenuItem>
                                            <MenuItem value="Karnataka">Karnataka</MenuItem>
                                        </>
                                    )}
                                    {country === "USA" && (
                                        <>
                                            <MenuItem value="California">California</MenuItem>
                                            <MenuItem value="Texas">Texas</MenuItem>
                                        </>
                                    )}
                                </Select>
                            </div>

                            {/* Tax Type */}
                            <div className="control_group w_50">
                                <label htmlFor="tax-type">Tax Type</label>
                                <Select
                                    fullWidth
                                    value={taxType}
                                    onChange={handleTaxTypeChange}
                                    inputProps={{ id: "tax-type" }}
                                >
                                    <MenuItem value="VAT">VAT</MenuItem>
                                    <MenuItem value="GST">GST</MenuItem>
                                    <MenuItem value="Sales Tax">Sales Tax</MenuItem>
                                    <MenuItem value="Service Tax">Service Tax</MenuItem>
                                </Select>
                            </div>

                            {/* Tax Rate */}
                            <div className="control_group w_50">
                                <label htmlFor="tax-rate">Tax Rate (%)</label>
                                <TextField
                                    type="number"
                                    placeholder="0.00"
                                    value={rate}
                                    onChange={(e) => setRate(e.target.value)}
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "tax-rate" }}
                                />
                            </div>

                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={() => setOpen(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpen(false)}
                            >
                                Add Tax Rate
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
